<template>
  <v-app>
    <IFrameCookies />


    <div v-if="isLogged" id="nav-1" class="parent-nav1">
      <div id="parentsticky" class="parent-relative">
        <div id="wallet-handler" class="wallet-sticky-container">
          <!-- Toggle Button -->
          <button 
            @click="toggleWallet"
            class="wallet-toggle-btn"
            :class="{ 'wallet-hidden': walletishidden }"
            :title="walletishidden ? 'Show Wallet' : 'Hide Wallet'"
          >
            <v-icon size="24" class="wallet-icon">
              {{ walletishidden ? 'mdi-wallet-outline' : 'mdi-wallet' }}
            </v-icon>
          </button>
          
          <!-- Wallet App Container -->
          <transition name="wallet-slide">
            <div v-if="!walletishidden" class="wallet-app-wrapper">
              <WalletApp/>
            </div>
          </transition>
        </div>
      </div>
    </div>


    <v-app-bar v-model="navbarhandle" app class="bg_std_color" v-if="isLogged">
      <div class="container-size-top">
        <v-row class="pl-2 mt-0 pt-2 pb-1">
          <v-col cols="3">
            <LogoWhite @click="handleClickMenu('muzible')"></LogoWhite>
          </v-col>
          <v-col cols="9" align="right" class="pl-2 pr-0 pt-4" style="position: relative;">


            <v-btn v-show="!this.isMobileXs" elevation="0" text plain :ripple="false"
              class="text-none nomenu-btn-page pl-0 pr-0 ml-0 mr-4" @click="handleClickMenu('MUZ')">
              <v-icon left class="pr-1" style="color:white!important">mdi-web</v-icon>
              <span class="pl-1" style="color:white!important">muzible.com</span>
            </v-btn>

            <v-btn v-show="this.isMobileXs" size="x-large" icon="mdi-web" @click="handleClickMenu('MUZ')"
            style="color: white!important;" class="mr-2 ml-1" variant="plain" density="compact" :ripple="false" >
            </v-btn>

            <v-btn v-show="!this.player" size="x-large" icon="mdi-record-player" variant="plain" density="compact" :ripple="false"
            style="color: white!important;" @click="openPlayer()" class="mr-2 ml-1">
            </v-btn>
            <v-btn v-show="this.player" size="x-large" icon="mdi-record-player" variant="plain" density="compact" :ripple="false"
            style="color: #1ff050!important;" @click="openPlayer()" class="mr-2 ml-1">
            </v-btn>

            <v-btn v-show="this.isMobileXs && !this.drawerham" size="x-large" icon="mdi-menu" variant="plain" density="compact" :ripple="false"
            style="color: white!important;"  @click.stop="openDrawer()" class="mr-1 ml-1">
            </v-btn>
            <v-btn v-show="this.isMobileXs && this.drawerham" size="x-large" icon="mdi-menu-open" variant="plain" density="compact" :ripple="false"
            style="color: white!important;"  @click.stop="openDrawer()" class="mr-1 ml-1">
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </v-app-bar>

    <v-bottom-navigation v-if="isLogged" :active="this.player" class="bg_std_color_bootom"
      :height="this.isMobilePlayer3 ? 124 : 84" style="overflow:visible;">
      <div :class="classNavigationBottom" >
        <MusicPlayer/>
      </div>
    </v-bottom-navigation>

    <v-navigation-drawer 
      v-if="isLogged" 
      :rail="rail" 
      :rail-width="110" 
      app 
      permanent 
      stateless 
      color="transparent"
      v-model="drawerham" 
      :class="classNavigation" 
      :width="320"
      :touch="{ left: false, right: false }"
      :touchless="false"
    >
      <v-container class="container-size-drawer">
        <div class="drawer-wrapper">
          <div 
            ref="drawerScrollContainer" 
            tabindex="0" 
            class="drawer-content" 
            :class="{ 'rail-mode': rail }"
            :style="{ maxHeight: drawerContentMaxHeight }"
            @touchstart="handleTouchStart" 
            @touchmove="handleTouchMove"
            @touchend="handleDrawerTouchEnd"
          >
            <!-- Header Section -->
            <div class="drawer-header">
              <div v-if="!railend" class="header-expanded">
                <!-- User Actions -->
                <div class="header-actions">
                  <v-btn 
                    icon="mdi-account-outline" 
                    variant="plain"
                    density="compact" 
                    size="large"
                    class="header-icon-btn"
                    @click.stop="handleClickMenu('account')"
                  />
                  
                  <v-btn 
                    icon="mdi-account-details-outline" 
                    variant="plain"
                    density="compact" 
                    size="large"
                    class="header-icon-btn"
                    @click.stop="handleClickMenu('settings')"
                  />
                  
                  <v-btn 
                    icon="mdi-shopping-outline" 
                    variant="plain"
                    density="compact" 
                    size="large"
                    class="header-icon-btn shop-btn"
                    @click.stop="handleClickMenu('SHOP')"
                  />
                </div>
                
                <!-- Close Button -->
                <v-btn 
                  v-show="!fullscreen"
                  icon="mdi-arrow-left" 
                  variant="plain"
                  density="compact" 
                  size="large"
                  class="header-close-btn"
                  @click.stop="closeDrawer()"
                />
              </div>
              
              <!-- Rail Mode - Open Button -->
              <div v-if="railend" class="header-rail">
                <v-btn 
                  icon="mdi-arrow-right" 
                  variant="plain"
                  density="compact" 
                  size="large"
                  class="header-open-btn"
                  @click.stop="closeDrawer()"
                />
              </div>
            </div>

            <!-- Menu List -->
            <v-list 
              nav 
              dense
              class="drawer-menu"
              :class="{ 'rail-mode': rail }"
            >
              <!-- Platform Banners - Expanded Mode -->
              <template v-if="!rail">
                <!-- MuzE Banner -->
                <div class="platform-banner mt-1" @click.stop="handleClickMenu('TryMuzE')">
                  <transition name="fade" mode="out-in">
                    <div v-show="isImageLoading" class="banner-loading">
                      <v-progress-circular indeterminate color="white" size="24" />
                    </div>
                  </transition>
                  <transition name="fade" mode="out-in">
                    <v-img 
                      v-show="!isImageLoading"
                      :src="muzeImage"
                      class="banner-image"
                      cover
                    >
                      <img 
                        @load="handleImageLoaded" 
                        :src="muzeImage"
                        style="display: none;" 
                      />
                      <div class="banner-overlay">
                        <span class="banner-text">MuzE</span>
                        <v-spacer />
                        <v-icon size="18" class="banner-icon">mdi-arrow-right-top</v-icon>
                      </div>
                    </v-img>
                  </transition>
                </div>

                <!-- Verse Banner -->
                <div class="platform-banner" @click.stop="handleClickMenu('TryVerse')">
                  <transition name="fade" mode="out-in">
                    <div v-show="isImageLoading2" class="banner-loading">
                      <v-progress-circular indeterminate color="white" size="24" />
                    </div>
                  </transition>
                  <transition name="fade" mode="out-in">
                    <v-img 
                      v-show="!isImageLoading2"
                      :src="verseImage"
                      class="banner-image"
                      cover
                    >
                      <img 
                        @load="handleImageLoaded2" 
                        :src="verseImage"
                        style="display: none;" 
                      />
                      <div class="banner-overlay">
                        <span class="banner-text">Verse</span>
                        <v-spacer />
                        <v-icon size="18" class="banner-icon">mdi-arrow-right-top</v-icon>
                      </div>
                    </v-img>
                  </transition>
                </div>

                <!-- Tickets Banner -->
                <div class="platform-banner" @click.stop="handleClickMenu('TryTickets')">
                  <transition name="fade" mode="out-in">
                    <div v-show="isImageLoading3" class="banner-loading">
                      <v-progress-circular indeterminate color="white" size="24" />
                    </div>
                  </transition>
                  <transition name="fade" mode="out-in">
                    <v-img 
                      v-show="!isImageLoading3"
                      :src="ticketsImage"
                      class="banner-image"
                      cover
                    >
                      <img 
                        @load="handleImageLoaded3" 
                        :src="ticketsImage"
                        style="display: none;" 
                      />
                      <div class="banner-overlay">
                        <span class="banner-text">Tickets</span>
                        <v-spacer />
                        <v-icon size="18" class="banner-icon">mdi-arrow-right-top</v-icon>
                      </div>
                    </v-img>
                  </transition>
                </div>

                <div class="menu-divider" />
              </template>

              <!-- Menu Items - Expanded Mode -->
              <template v-if="!rail">
                <v-list-item 
                  class="menu-item"
                  :class="{ 'active': $route.name === 'plan' }"
                  @click.stop="handleClickMenu('plan')"
                >
                  <v-list-item-title class="menu-item-text">
                    <v-icon size="18" class="menu-item-icon">mdi-card-account-details</v-icon>
                    Your plan
                  </v-list-item-title>
                </v-list-item>

                <v-list-item 
                  class="menu-item"
                  :class="{ 'active': $route.name === 'wallet' }"
                  @click.stop="handleClickMenu('wallet')"
                >
                  <v-list-item-title class="menu-item-text">
                    <v-icon size="18" class="menu-item-icon">mdi-wallet</v-icon>
                    Wallet
                  </v-list-item-title>
                </v-list-item>

                <v-list-item 
                  class="menu-item"
                  :class="{ 'active': $route.name === 'tickets' }"
                  @click.stop="handleClickMenu('tickets')"
                >
                  <v-list-item-title class="menu-item-text">
                    <v-icon size="18" class="menu-item-icon">mdi-ticket</v-icon>
                    Your tickets
                  </v-list-item-title>
                </v-list-item>

                <v-list-item 
                  class="menu-item"
                  :class="{ 'active': $route.name === 'collections' }"
                  @click.stop="handleClickMenu('collections')"
                >
                  <v-list-item-title class="menu-item-text">
                    <v-icon size="18" class="menu-item-icon">mdi-bookshelf</v-icon>
                    Collections
                  </v-list-item-title>
                </v-list-item>

                <v-list-item 
                  class="menu-item"
                  :class="{ 'active': $route.name === 'nftcollection' }"
                  @click.stop="handleClickMenu('nftcollection')"
                >
                  <v-list-item-title class="menu-item-text">
                    <v-icon size="18" class="menu-item-icon">mdi-play-box-multiple</v-icon>
                    NFT
                  </v-list-item-title>
                </v-list-item>

                <v-list-item 
                  class="menu-item"
                  :class="{ 'active': $route.name === 'subscription' }"
                  @click.stop="handleClickMenu('subscription')"
                >
                  <v-list-item-title class="menu-item-text">
                    <v-icon size="18" class="menu-item-icon">mdi-star</v-icon>
                    Subscriptions
                  </v-list-item-title>
                </v-list-item>

                <v-list-item 
                  class="menu-item"
                  :class="{ 'active': $route.name === 'exchange' }"
                  @click.stop="handleClickMenu('exchange')"
                >
                  <v-list-item-title class="menu-item-text">
                    <v-icon size="18" class="menu-item-icon">mdi-swap-horizontal</v-icon>
                    Exchange
                  </v-list-item-title>
                </v-list-item>

                <v-list-item 
                  class="menu-item"
                  :class="{ 'active': $route.name === 'nft' }"
                  @click.stop="handleClickMenu('nft')"
                >
                  <v-list-item-title class="menu-item-text">
                    <v-icon size="18" class="menu-item-icon">mdi-shopping</v-icon>
                    NFT Market
                  </v-list-item-title>
                </v-list-item>

                <div class="menu-divider large" />

                <v-list-item 
                  class="menu-item"
                  :class="{ 'active': $route.name === 'messenger' }"
                  @click.stop="handleClickMenu('messenger')"
                >
                  <v-list-item-title class="menu-item-text">
                    <v-icon size="18" class="menu-item-icon">mdi-message</v-icon>
                    Messenger
                  </v-list-item-title>
                </v-list-item>

                <v-list-item 
                  class="menu-item"
                  :class="{ 'active': $route.name === 'statistics' }"
                  @click.stop="handleClickMenu('statistics')"
                >
                  <v-list-item-title class="menu-item-text">
                    <v-icon size="18" class="menu-item-icon">mdi-chart-bar</v-icon>
                    Statistics
                  </v-list-item-title>
                </v-list-item>

                <v-list-item 
                  class="menu-item"
                  :class="{ 'active': $route.name === 'ticketing' }"
                  @click.stop="handleClickMenu('ticketing')"
                >
                  <v-list-item-title class="menu-item-text">
                    <v-icon size="18" class="menu-item-icon">mdi-ticket-confirmation</v-icon>
                    Ticketing
                  </v-list-item-title>
                </v-list-item>

                <v-list-item 
                  class="menu-item"
                  :class="{ 'active': $route.name === 'payment' }"
                  @click.stop="handleClickMenu('payment')"
                >
                  <v-list-item-title class="menu-item-text">
                    <v-icon size="18" class="menu-item-icon">mdi-credit-card</v-icon>
                    Top Up
                  </v-list-item-title>
                </v-list-item>

                <v-list-item 
                  class="menu-item"
                  :class="{ 'active': $route.name === 'billing' }"
                  @click.stop="handleClickMenu('billing')"
                >
                  <v-list-item-title class="menu-item-text">
                    <v-icon size="18" class="menu-item-icon">mdi-receipt</v-icon>
                    Billing
                  </v-list-item-title>
                </v-list-item>

                <v-list-item 
                  class="menu-item"
                  :class="{ 'active': $route.name === 'api' }"
                  @click.stop="handleClickMenu('api')"
                >
                  <v-list-item-title class="menu-item-text">
                    <v-icon size="18" class="menu-item-icon">mdi-api</v-icon>
                    API
                  </v-list-item-title>
                </v-list-item>

                <div class="menu-divider large" />

                <v-list-item 
                  class="menu-item logout"
                  @click.stop="handleClickMenu('logout')"
                >
                  <v-list-item-title class="menu-item-text">
                    <v-icon size="18" class="menu-item-icon">mdi-logout</v-icon>
                    Log out
                  </v-list-item-title>
                </v-list-item>
              </template>

              <!-- Rail Mode - Icon Only -->
              <template v-if="rail">
                <div 
                  class="rail-item" 
                  :class="{ 'rail-active': $route.name === 'plan' }"
                  @click.stop="handleClickMenu('plan')"
                >
                  <v-icon size="24" class="rail-icon-v">mdi-card-account-details</v-icon>
                  <v-tooltip activator="parent" location="end">Your plan</v-tooltip>
                </div>

                <div 
                  class="rail-item" 
                  :class="{ 'rail-active': $route.name === 'wallet' }"
                  @click.stop="handleClickMenu('wallet')"
                >
                  <v-icon size="24" class="rail-icon-v">mdi-wallet</v-icon>
                  <v-tooltip activator="parent" location="end">Wallet</v-tooltip>
                </div>

                <div 
                  class="rail-item" 
                  :class="{ 'rail-active': $route.name === 'tickets' }"
                  @click.stop="handleClickMenu('tickets')"
                >
                  <v-icon size="24" class="rail-icon-v">mdi-ticket</v-icon>
                  <v-tooltip activator="parent" location="end">Your tickets</v-tooltip>
                </div>

                <div 
                  class="rail-item" 
                  :class="{ 'rail-active': $route.name === 'collections' }"
                  @click.stop="handleClickMenu('collections')"
                >
                  <v-icon size="24" class="rail-icon-v">mdi-bookshelf</v-icon>
                  <v-tooltip activator="parent" location="end">Collections</v-tooltip>
                </div>

                <div 
                  class="rail-item" 
                  :class="{ 'rail-active': $route.name === 'nftcollection' }"
                  @click.stop="handleClickMenu('nftcollection')"
                >
                  <v-icon size="24" class="rail-icon-v">mdi-play-box-multiple</v-icon>
                  <v-tooltip activator="parent" location="end">NFT</v-tooltip>
                </div>

                <div 
                  class="rail-item" 
                  :class="{ 'rail-active': $route.name === 'subscription' }"
                  @click.stop="handleClickMenu('subscription')"
                >
                  <v-icon size="24" class="rail-icon-v">mdi-star</v-icon>
                  <v-tooltip activator="parent" location="end">Subscriptions</v-tooltip>
                </div>

                <div 
                  class="rail-item" 
                  :class="{ 'rail-active': $route.name === 'exchange' }"
                  @click.stop="handleClickMenu('exchange')"
                >
                  <v-icon size="24" class="rail-icon-v">mdi-swap-horizontal</v-icon>
                  <v-tooltip activator="parent" location="end">Exchange</v-tooltip>
                </div>

                <div 
                  class="rail-item" 
                  :class="{ 'rail-active': $route.name === 'nft' }"
                  @click.stop="handleClickMenu('nft')"
                >
                  <v-icon size="24" class="rail-icon-v">mdi-shopping</v-icon>
                  <v-tooltip activator="parent" location="end">NFT Market</v-tooltip>
                </div>

                <div class="menu-divider large" />

                <div 
                  class="rail-item" 
                  :class="{ 'rail-active': $route.name === 'messenger' }"
                  @click.stop="handleClickMenu('messenger')"
                >
                  <v-icon size="24" class="rail-icon-v">mdi-message</v-icon>
                  <v-tooltip activator="parent" location="end">Messenger</v-tooltip>
                </div>

                <div 
                  class="rail-item" 
                  :class="{ 'rail-active': $route.name === 'statistics' }"
                  @click.stop="handleClickMenu('statistics')"
                >
                  <v-icon size="24" class="rail-icon-v">mdi-chart-bar</v-icon>
                  <v-tooltip activator="parent" location="end">Statistics</v-tooltip>
                </div>

                <div 
                  class="rail-item" 
                  :class="{ 'rail-active': $route.name === 'ticketing' }"
                  @click.stop="handleClickMenu('ticketing')"
                >
                  <v-icon size="24" class="rail-icon-v">mdi-ticket-confirmation</v-icon>
                  <v-tooltip activator="parent" location="end">Ticketing</v-tooltip>
                </div>

                <div 
                  class="rail-item" 
                  :class="{ 'rail-active': $route.name === 'payment' }"
                  @click.stop="handleClickMenu('payment')"
                >
                  <v-icon size="24" class="rail-icon-v">mdi-credit-card</v-icon>
                  <v-tooltip activator="parent" location="end">Top Up</v-tooltip>
                </div>

                <div 
                  class="rail-item" 
                  :class="{ 'rail-active': $route.name === 'billing' }"
                  @click.stop="handleClickMenu('billing')"
                >
                  <v-icon size="24" class="rail-icon-v">mdi-receipt</v-icon>
                  <v-tooltip activator="parent" location="end">Billing</v-tooltip>
                </div>

                <div 
                  class="rail-item" 
                  :class="{ 'rail-active': $route.name === 'api' }"
                  @click.stop="handleClickMenu('api')"
                >
                  <v-icon size="24" class="rail-icon-v">mdi-api</v-icon>
                  <v-tooltip activator="parent" location="end">API</v-tooltip>
                </div>

                <div class="menu-divider large" />

                <div class="rail-item logout-rail" @click.stop="handleClickMenu('logout')">
                  <v-icon size="24" class="rail-icon-v logout-icon">mdi-logout</v-icon>
                  <v-tooltip activator="parent" location="end">Log out</v-tooltip>
                </div>
              </template>
            </v-list>
          </div>
        </div>
      </v-container>
    </v-navigation-drawer>

    <CookieConsent class="ma-0" />
    <v-main id="parent-civ">
      <router-view v-slot="{ Component }" :class="{ 'disable-scroll': isLogged }">
        <Transition name="fade" mode="out-in">
          <component :is="Component" />
        </Transition>
      </router-view>
    </v-main>




<v-dialog
  v-model="showTransactionProgressBox"
  max-width="500"
  persistent
  class="transaction-dialog"
>
  <v-card class="transaction-card">
    <!-- Header -->
    <v-card-title class="transaction-header">
      <div class="header-logo">
        <LogoWhite></LogoWhite>
      </div>
    </v-card-title>

    <!-- Content -->
    <v-card-text class="transaction-content">
      <!-- Warning Alert -->
      <v-alert
        type="warning"
        variant="outlined"
        class="transaction-alert mb-4"
        icon="mdi-alert-circle"
      >
        <div class="alert-title">DO NOT CLOSE THIS WINDOW</div>
        <div class="alert-text">Transaction must be confirmed before closing</div>
      </v-alert>

      <!-- Info Sections -->
      <div class="info-section">
        <v-icon size="20" color="white" class="mr-2">mdi-information</v-icon>
        <p class="info-text">
          If after confirmation transaction takes longer than 5 minutes, cancel it in MetaMask and start again (probably gas fee was too small).
        </p>
      </div>

      <div class="info-section">
        <v-icon size="20" color="white" class="mr-2">mdi-hand-pointing-right</v-icon>
        <p class="info-text">
          Confirm Transaction and wait until CLOSE button is reactivated.
        </p>
      </div>

      <v-divider class="my-4" style="opacity: 0.2;"></v-divider>

      <!-- Status Section -->
      <div v-if="sending" class="status-section status-pending">
        <v-progress-circular
          indeterminate
          color="white"
          size="48"
          width="3"
          class="mb-3"
        ></v-progress-circular>
        <div class="status-title blink">Transaction in progress</div>
        <div class="status-subtitle">Please wait and don't close this window...</div>
      </div>

      <div v-if="!sending && transactionResults && !metamaskError" class="status-section status-success">
        <v-icon size="64" color="success" class="mb-3">mdi-check-circle</v-icon>
        <div class="status-title">Transaction finished</div>
        <div class="status-subtitle">Your transaction has been successfully completed</div>
      </div>
      <div v-else-if="!sending && transactionResults && metamaskError" class="status-section status-failed">
        <v-icon size="64" color="error" class="mb-3">mdi-close-circle</v-icon>
        <div class="status-title">Transaction failed</div>
        <div class="status-subtitle">There was an error processing your transaction</div>
      </div>

      <!-- Transaction Hash -->
      <div v-if="!sending && transactionResults" class="transaction-hash-section">
        <div class="hash-label">
          <v-icon size="16" class="mr-1">mdi-link-variant</v-icon>
          Transaction Hash:
        </div>
        <div class="hash-value">
          {{ transactionResults.transactionHash }}
        </div>
        <v-btn
          variant="text"
          size="small"
          prepend-icon="mdi-content-copy"
          @click="copyToClipboard(transactionResults.transactionHash)"
          class="copy-btn"
        >
          Copy Hash
        </v-btn>
      </div>
    </v-card-text>

    <!-- Actions -->
    <v-card-actions class="transaction-actions">
      <v-spacer></v-spacer>
      <v-btn
        variant="outlined"
        :disabled="sending"
        @click="showTransactionProgressBox = false; metamaskError=''; transactionResults=null; sending=false;"
        class="close-btn"
        size="large"
      >
        <v-icon left v-if="!sending">mdi-check</v-icon>
        <v-icon left v-else>mdi-clock-outline</v-icon>
        {{ sending ? 'Please Wait...' : 'Close' }}
      </v-btn>
      <v-spacer></v-spacer>
    </v-card-actions>
  </v-card>
</v-dialog>


  </v-app>
</template>

<script>

import { useMobile } from './composables/useMobile.js'
import { useMobileXs } from './composables/useMobileXs.js'
import { useMobilePlayer3 } from "@/composables/useMobilePlayer3.js";
import LogoBlack from '@/components/logo_black.vue'
import LogoBlackLogotyp from '@/components/logo_logotyp.vue'
import LogoWhiteLogotyp from '@/components/logo_logotyp_white.vue'
import LogoColorLogotyp from '@/components/logo_logotyp_color.vue'
import LogoMusic from '@/components/logo_music.vue'
import LogoWhite from '@/components/logo_white.vue'
import LogoRed from '@/components/logo_red.vue'
import LogoVerse from '@/components/logo_verse.vue'
import CookieConsent from '@/components/CookieConsent.vue';
import MusicPlayer from './components/MusicPlayer.vue'
import IFrameCookies from './components/IFrameCookies.vue'
import WalletApp from './components/WalletApp'
import { toast } from "vue3-toastify";

export default {
  provide() {
    return {
      playerState: () => this.player,
    }
  },

  setup() {
    const isMobile = useMobile()
    const isMobileXs = useMobileXs()
    const isMobilePlayer3 = useMobilePlayer3()

    const notify = (message) => {
      toast(message, {
        theme: "dark",
        type: "success",
        position: "bottom-center",
        closeOnClick: false,
        pauseOnHover: false,
        autoClose: 1500,
        transition: "flip",
        dangerouslyHTMLString: true,
      });
    };

    return { isMobile, isMobileXs, isMobilePlayer3, notify }
  },
  name: 'App',

  components: {
    LogoBlack,
    LogoBlackLogotyp,
    LogoWhiteLogotyp,
    LogoColorLogotyp,
    LogoMusic,
    LogoWhite,
    CookieConsent,
    LogoRed,
    LogoVerse,
    MusicPlayer,
    IFrameCookies,
    WalletApp
  },

  data: () => ({
    drawerOpacity: 1,
    drawermargin: '44px',
    drawerham: true,
    player: true,
    fullscreen: false,
    rail: false,
    railend: false,
    navbarhandle: true,
    isImageLoading: true,
    isImageLoading2: true,
    isImageLoading3: true,

    showTransactionProgressBox: false,
    sending: false,
    transactionResults: null,

    walletishidden: false,

    touchStartY: 0,
    touchStartX: 0,
    isDrawerTouched: false,

    metamaskError: '',

    muzeImage: require('@/assets/images/muzible_muze.webp'),
    verseImage: require('@/assets/images/muzible_verse.webp'),
    ticketsImage: require('@/assets/images/muzible_tickets.webp'),

  }),
  mounted() {
    window.addEventListener('resize', this.checkScreenSize);
    if (window.innerWidth > 768) {
      this.fullscreen = true;
      this.rail = false;
      this.railend = this.rail;
    } else {
      this.fullscreen = false;
      if (this.isMobileXs) {
        this.rail = false;
        this.railend = this.rail;
        this.drawerham = false;
      } else {
        this.rail = true;
        this.railend = true;
        this.drawerham = true;
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScreenSize);
  },
  beforeMount() {
    //const clientID = 'AdbYGv_mseOsNV_ZWn3phjUz8GFirzDNzAUwIsKeuJbbwf7QBqQ07K93g7PRR-sL32ihAIvQ4rugQlBw';
    //const src = `https://www.paypal.com/sdk/js?client-id=${clientID}`;
    //if (document.querySelectorAll(`head script[src="${src}"]`).length <= 0) {
    //  const script = document.createElement('script');
    //  script.setAttribute('src', src);
    //  document.head.appendChild(script);
    //} 
    
    //const src2 = `https://accounts.google.com/gsi/client`;
    //if (document.querySelectorAll(`head script[src="${src2}"]`).length <= 0) {
    //  const script2 = document.createElement('script');
    //  script2.async = true;
    //  script2.defer = true;
    //  script2.setAttribute('src', src2);
    //  document.head.appendChild(script2);
    //}     
  },
  created() {
  

    if (this.$store.getters.getUserData != null) {
      if (window.innerWidth > 768) {
        this.fullscreen = true;
        this.rail = false;
        this.railend = this.rail;
      } else {
        this.fullscreen = false;
        if (this.isMobileXs) {
          this.rail = false;
          this.railend = this.rail;
          this.drawerham = false;
        } else {
          this.rail = true;
          this.railend = true;
          this.drawerham = true;
        }
      }
    }

    this.emitter.on('transactionInProgress', () => {
            this.sending = true;
            this.transactionResults = null;
            this.showTransactionProgressBox = true;
    })
    this.emitter.on('transactionInProgressEnd', () => {
            this.sending = false;
    })
    this.emitter.on('transactionData', (results) => {
            this.transactionResults = results;
    })
    this.emitter.on('transactionInProgressEndError', (data) => {
            this.metamaskError = data;
    })

    this.checkScreenSize();
  },
  computed: {
    classNavigation() {
      if (this.rail) {
        return 'navigationMobile';
      } else return 'navigationStandard';
    },
    classNavigationBottom() {
      if (this.isMobilePlayer3) {
        return 'bg_std_color_bootom-card-mobile';
      } else return 'bg_std_color_bootom-card';
    },
    isLogged() {
      return this.$store.getters.getUserData != null
    },
    drawerContentMaxHeight() {
    const appBarHeight = 64; // v-app-bar height
    const margins = 32; // top + bottom margins w drawer
    
    // Wysokość playera - musi być zsynchronizowana z v-bottom-navigation
    let playerHeight = 0;
    if (this.player) {
      playerHeight = this.isMobilePlayer3 ? 124 : 84;
    }
    
    const totalOffset = appBarHeight + playerHeight + margins;
    return `calc(100dvh - ${totalOffset}px)`;
    },
  },
  methods: {

    handleTouchStart(event) {
      this.touchStartY = event.touches[0].clientY
      this.touchStartX = event.touches[0].clientX
      this.isDrawerTouched = true;

      if (event.target.closest('.overlay-grey')) {
        event.target.closest('.overlay-grey').focus({ preventScroll: true });
      }

      const drawerContainer = this.$refs.drawerScrollContainer;
      if (drawerContainer) {
        drawerContainer.focus({ preventScroll: true });
      }

    },

    handleTouchMove(event) {
      if (!this.isDrawerTouched) return;
      
      const drawerContainer = this.$refs.drawerScrollContainer;
      if (!drawerContainer) return;

      const touchY = event.touches[0].clientY;
      const deltaY = touchY - this.touchStartY;

      // Sprawdź pozycję scroll w drawer
      const scrollTop = drawerContainer.scrollTop;
      const scrollHeight = drawerContainer.scrollHeight;
      const clientHeight = drawerContainer.clientHeight;

      const isAtTop = scrollTop <= 0;
      const isAtBottom = scrollTop + clientHeight >= scrollHeight - 1;

      const scrollingUp = deltaY > 0; // Ruch w dół (scroll up)
      const scrollingDown = deltaY < 0; // Ruch w górę (scroll down)

      // Prevent scroll na body tylko gdy drawer może scrollować
      if ((scrollingUp && !isAtTop) || (scrollingDown && !isAtBottom)) {
        // Drawer może scrollować - zablokuj body
        event.stopPropagation();
      } else if ((scrollingUp && isAtTop) || (scrollingDown && isAtBottom)) {
        // Drawer jest na końcu - pozwól scrollować body
        // Nie rób nic - event propaguje do body
      } else {
        // W innych przypadkach zablokuj
        event.stopPropagation();
      }
    },

    handleDrawerTouchEnd(event) {
      this.isDrawerTouched = false;
      this.touchStartY = 0;
      this.touchStartX = 0;
    },

    handleImageLoaded() {
      this.isImageLoading = false;
    },
    handleImageLoaded2() {
      this.isImageLoading2 = false;
    },
    handleImageLoaded3() {
      this.isImageLoading3 = false;
    },
    checkScreenSize() {
      if (window.innerWidth > 768) {
        this.fullscreen = true;
        this.rail = false;
        this.railend = this.rail;
        this.drawerham = true;
      } else {
        this.fullscreen = false;
        if (this.isMobileXs) {
          this.rail = false;
          this.railend = this.rail;
          this.drawerham = false;
        } else {
          this.rail = true;
          this.railend = this.rail;
          this.drawerham = true;
        }
      }
    },
    closeDrawer() {
      if (!this.rail) {
        this.rail = !this.rail;
        this.railend = this.rail;
      } else {
        this.rail = !this.rail;
        setTimeout(() => {
          this.railend = this.rail;
        }, 300);
      }

      if (!this.rail) {
        this.$nextTick(() => {
          const drawerContainer = this.$refs.drawerScrollContainer;
          if (drawerContainer) {
            drawerContainer.focus({ preventScroll: true });
            drawerContainer.scrollTop = 0;
          }
        });
      }

    },
    openDrawer() {
      this.drawerham = !this.drawerham;
    },
    openPlayer() {
      this.player = !this.player;
    },
    handleClickMenu(link) {
      if (link === 'TryMuzE') {
        window.location.href = 'https://muze.muzible.com/';
      } else if (link === 'TryVerse') {
        window.location.href = 'https://verse.muzible.com/';
      } else if (link === 'TryTickets') {
        window.location.href = 'https://tickets.muzible.com/';
      } else if (link === 'SHOP') {
        window.location.href = 'https://shop.muzible.com/';
      } else if (link === 'MUZ') {
        window.location.href = 'https://muzible.com/';
      } else {
        if (this.$route.name !== link) {
          this.$router.push({ name: link });
        }
      }
    },
    toggleWallet() {
      this.walletishidden = !this.walletishidden;
    },
    hiddewallet() {
      this.walletishidden = true;
    },
    openwallet() {
      this.walletishidden = false;
    },
      copyToClipboard(text) {
        navigator.clipboard.writeText(text).then(() => {
          // Możesz dodać toast notification
          console.log('Hash copied to clipboard');
          this.notify('Transaction hash copied to clipboard!');
        }).catch(err => {
          console.error('Failed to copy:', err);
        });
      },
  },
  watch: {
    '$route': {
      handler: (to, from) => {
        document.title = to.meta.title || 'Muzible'
      },
      immediate: true
    },
    drawerham(newVal, oldVal) {
      if (newVal && !oldVal) {
        // Drawer został otwarty
        this.$nextTick(() => {
          const drawerContainer = this.$refs.drawerScrollContainer;
          if (drawerContainer) {
            drawerContainer.focus({ preventScroll: true });
            drawerContainer.scrollTop = 0;
          }
        });
      }
    },
  }
}
</script>


<style lang="scss">
@use './views/css/styles.scss';

@keyframes blink {
  0% {
    opacity: 1;
  }
  40% {
    opacity: 1;
  }
  60% {
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}

/* Wallet Sticky Container */
.parent-nav1 {
  position: fixed !important;
  top: 68px;
  right: 0;
  z-index: 200;
  pointer-events: none;
}

.parent-relative {
  position: relative !important;
  width: 100%;
  pointer-events: none;
}

.wallet-sticky-container {
  display: flex;
  align-items: stretch;
  gap: 0;
  margin-left: auto;
  margin-right: 0;
  pointer-events: auto;
  position: relative;
  height: auto;
}

/* Wallet Toggle Button */
.wallet-toggle-btn {
  width: 48px;
  min-height: 48px;
  height: auto;
  background: linear-gradient(135deg, #007bff, #0056b3);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-top-left-radius: 12px;
  border-bottom-left-radius: 12px;
  border-right: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.3s ease, box-shadow 0.3s ease, transform 0.3s ease;
  box-shadow: -4px 4px 12px rgba(0, 0, 0, 0.4);
  position: relative;
  z-index: 10;
  flex-shrink: 0;
}

.wallet-toggle-btn:hover {
  background: linear-gradient(135deg, #0056b3, #003d82);
  box-shadow: -6px 6px 16px rgba(0, 0, 0, 0.5);
  transform: translateX(-2px);
}

.wallet-toggle-btn.wallet-hidden {
  background: linear-gradient(135deg, #6c757d, #495057);
  border-color: rgba(255, 255, 255, 0.2);
  height: 48px;
  min-height: 48px;
}

.wallet-toggle-btn.wallet-hidden:hover {
  background: linear-gradient(135deg, #495057, #343a40);
}

.wallet-icon {
  color: white !important;
  transition: transform 0.3s ease;
  flex-shrink: 0;
}

.wallet-toggle-btn:hover .wallet-icon {
  transform: scale(1.1);
}

/* Wallet App Wrapper */
.wallet-app-wrapper {
  width: 360px;
  flex-shrink: 0;
  position: relative;
  overflow: visible;
  display: flex;
  flex-direction: column;
}

/* Wallet Slide Animation */
.wallet-slide-enter-active {
  animation: slideInRight 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.wallet-slide-leave-active {
  animation: slideOutRight 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

@keyframes slideInRight {
  from {
    opacity: 0;
    transform: translateX(100%);
    max-width: 0;
    width: 0;
  }
  to {
    opacity: 1;
    transform: translateX(0);
    max-width: 360px;
    width: 360px;
  }
}

@keyframes slideOutRight {
  from {
    opacity: 1;
    transform: translateX(0);
    max-width: 360px;
    width: 360px;
  }
  to {
    opacity: 0;
    transform: translateX(100%);
    max-width: 0;
    width: 0;
  }
}

/* Legacy classes */
.wallet-btn-open,
.wallet-btn-hidden {
  display: none !important;
}

.fixed-top {
  display: none !important;
}

.horizontalTranslate {
  transition: transform 0.4s ease !important;
  transform: translateX(360px) !important;
}

.horizontalTranslateBack {
  transition: transform 0.4s ease !important;
  transform: translateX(0) !important;
}

/* Navigation Drawer Styles */
.navigationStandard,
.navigationMobile {
  background-color: transparent !important;
  position: fixed !important;
  top: 64px !important;
  left: 0 !important;
  min-height: 100dvh !important;
  padding: 0 !important;
  margin: 0 !important;
  opacity: 1 !important;
  z-index: 100 !important;
  border-right: 0px solid transparent !important;
  -webkit-overflow-scrolling: touch !important;
  touch-action: pan-y !important;
  overscroll-behavior: contain !important;
}

.navigationStandard {
  max-width: 320px !important;
}

.navigationMobile {
  max-width: 320px !important;
}

/* Container */
.container-size-drawer {
  padding-right: 24px !important;
  padding-left: 24px !important;
  background-color: transparent !important;
  display: flex;
  flex-direction: column;
  height: calc(100dvh - 64px); /* Od góry app-bar */
  max-height: calc(100dvh - 64px);
  border: 0px solid transparent!important;
}

/* Drawer Wrapper */
.drawer-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  flex: 1;
    max-height: 100%;
}

/* Drawer Content */
.drawer-content {
  background: linear-gradient(145deg, rgba(26, 26, 26, 0.98), rgba(18, 18, 18, 0.98));
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  padding: 16px;
  overflow-y: auto;
  overflow-x: hidden;
  flex-grow: 1;
  min-height: 0; /* Ważne! */
  //max-height: calc(100dvh - 180px); /* 64px app-bar + 84px player + 32px margins */
  scrollbar-width: none; /* Firefox - ukrywa scrollbar */
  -ms-overflow-style: none; /* IE/Edge - ukrywa scrollbar */
  -webkit-overflow-scrolling: touch !important;
  touch-action: pan-y !important;
  overscroll-behavior: contain !important;
  outline: none !important;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(10px);
  margin-bottom: 16px;
}

.drawer-content.rail-mode {
  padding: 6px!important;
  margin: 0px!important;
}

.drawer-content::-webkit-scrollbar {
  display: none;
  width: 0;
  height: 0;
  background: transparent;
}

.drawer-content::-webkit-scrollbar-track {
  display: none;
  background: transparent;
}

.drawer-content::-webkit-scrollbar-thumb {
  display: none;
  background: transparent;
}

.drawer-content::-webkit-scrollbar-thumb:hover {
  display: none;
  background: transparent;
}

/* Drawer Header */
.drawer-header {
  padding: 16px 8px 24px 8px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  margin-bottom: 16px;
}

.header-expanded {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
}

.header-actions {
  display: flex;
  gap: 4px;
  flex: 1;
}

.header-icon-btn {
  color: white !important;
  transition: all 0.3s ease;
}

.header-icon-btn:hover {
  background: rgba(255, 255, 255, 0.1) !important;
  transform: scale(1.1);
}

.header-icon-btn.shop-btn {
  color: #f0e556 !important;
}

.header-close-btn,
.header-open-btn {
  color: white !important;
  transition: all 0.3s ease;
}

.header-close-btn:hover,
.header-open-btn:hover {
  background: rgba(255, 255, 255, 0.15) !important;
  transform: translateX(-4px);
}

.header-rail {
  display: flex;
  justify-content: center;
  padding: 8px 0;
}

.header-open-btn:hover {
  transform: translateX(4px);
}

/* Drawer Menu */
.drawer-menu {
  padding: 0 !important;
  background: transparent !important;
}

.drawer-menu.rail-mode {
  padding: 2px 0px !important;
  margin: 0px!important;
}

/* Platform Banners */
.platform-banner {
  position: relative;
  height: 52px;
  margin-bottom: 12px;
  cursor: pointer;
  border-radius: 10px;
  overflow: hidden;
  transition: all 0.3s ease;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.platform-banner:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.4);
  border-color: rgba(255, 255, 255, 0.4);
}

.banner-loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
}

.banner-image {
  height: 52px !important;
  border-radius: 10px;
}

.banner-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  padding: 0 16px;
  transition: all 0.3s ease;
  border-radius: 10px;
}

.platform-banner:hover .banner-overlay {
  background: rgba(0, 0, 0, 0.4);
}

.banner-text {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 20px;
  font-weight: 700;
  color: white;
  letter-spacing: 0.5px;
}

.banner-icon {
  color: white !important;
  opacity: 0.8;
  transition: all 0.3s ease;
}

.platform-banner:hover .banner-icon {
  opacity: 1;
  transform: translate(2px, -2px);
}

/* Menu Divider */
.menu-divider {
  height: 1px;
  background: rgba(255, 255, 255, 0.1);
  margin: 16px 0;
}

.menu-divider.large {
  margin: 24px 0;
}

/* Menu Items */
.menu-item {
  min-height: 44px !important;
  padding: 0 16px !important;
  margin-right: 4px !important;
  margin-bottom: 4px;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid transparent;
}

.menu-item:hover {
  background: rgba(255, 255, 255, 0.1) !important;
  border-color: rgba(255, 255, 255, 0.2);
  transform: translateX(4px);
}

.menu-item.primary {
  background: rgba(0, 123, 255, 0.15);
  border-color: rgba(0, 123, 255, 0.3);
}

.menu-item.active {
  background: rgba(0, 123, 255, 0.25) !important;
  border-color: rgba(0, 123, 255, 0.5);
  transform: translateX(2px);
}

.menu-item.active .menu-item-icon {
  color: white !important;
}

.menu-item.primary:hover {
  background: rgba(0, 123, 255, 0.25) !important;
  border-color: rgba(0, 123, 255, 0.5);
}

.menu-item.primary.active {
  background: rgba(0, 123, 255, 0.25) !important;
  border-color: rgba(0, 123, 255, 0.5);
}

.menu-item.logout {
  background: rgba(227, 66, 52, 0.1);
  border-color: rgba(227, 66, 52, 0.3);
}

.menu-item.logout:hover {
  background: rgba(227, 66, 52, 0.2) !important;
  border-color: rgba(227, 66, 52, 0.5);
}

.menu-item.logout .menu-item-text {
  color: #E34234 !important;
}

.menu-item-text {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  color: white !important;
  display: flex !important;
  align-items: center !important;
  gap: 12px !important;
  letter-spacing: 0.3px;
}

@media (max-width: 768px) {
  .container-size-drawer {
    height: calc(100dvh - 64px);
    max-height: calc(100dvh - 64px);
  }

}

@media (max-width: 480px) {
  .container-size-drawer {
    padding-right: 16px !important;
    padding-left: 16px !important;
    height: calc(100dvh - 64px);
    max-height: calc(100dvh - 64px);
  }

  .drawer-content {
    padding: 12px;
    min-height: 0;
  }

  .drawer-header {
    padding: 12px 4px 16px 4px;
  }

  .platform-banner {
    height: 44px;
  }

  .banner-image {
    height: 44px !important;
  }

  .banner-text {
    font-size: 16px;
  }
}


.menu-item-icon {
  color: rgba(255, 255, 255, 0.8) !important;
  transition: color 0.3s ease;
}

.menu-item:hover .menu-item-icon {
  color: white !important;
}

.menu-item.logout .menu-item-icon {
  color: #E34234 !important;
}

/* Rail Mode Items */
.rail-item {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px 0;
  cursor: pointer;
  transition: all 0.3s ease;
  border-radius: 10px;
  margin-bottom: 8px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid transparent;
}

.rail-item:hover {
  background: rgba(255, 255, 255, 0.1);
  transform: scale(1.05);
}

.rail-item.rail-active {
  background: rgba(0, 123, 255, 0.25) !important;
  transform: scale(1.05);
}

.rail-item.rail-active .rail-icon-v {
  color: white !important;
  transform: scale(1.1);
}

.rail-item.logout-rail {
  background: rgba(227, 66, 52, 0.1);
}

.rail-item.logout-rail:hover {
  background: rgba(227, 66, 52, 0.2);
}

.rail-icon {
  filter: drop-shadow(0 2px 8px rgba(0, 0, 0, 0.3));
  transition: filter 0.3s ease;
}

.rail-item:hover .rail-icon {
  filter: drop-shadow(0 4px 12px rgba(0, 0, 0, 0.5));
}

/* Vuetify Overrides for Drawer */
:deep(.v-navigation-drawer__content) {
  overflow: hidden !important;
}

:deep(.v-list-item__overlay) {
  opacity: 0 !important;
}

:deep(.v-list-item:hover .v-list-item__overlay) {
  opacity: 0 !important;
}

:deep(.v-list) {
  padding: 0 !important;
}

:deep(.v-list-item) {
  padding: 0 !important;
}

:deep(.v-list-item-title) {
  font-size: inherit !important;
  font-weight: inherit !important;
}

/* Transaction Dialog Styles */
.transaction-dialog {
  :deep(.v-overlay__content) {
    border-radius: 16px;
  }
}

.rail-icon-v {
  color: rgba(255, 255, 255, 0.8) !important;
  transition: all 0.3s ease;
}

.rail-item:hover .rail-icon-v {
  color: white !important;
  transform: scale(1.1);
}

.rail-icon-v.logout-icon {
  color: #E34234 !important;
}

.rail-item.logout-rail:hover .rail-icon-v.logout-icon {
  color: #ff5a4d !important;
}

.transaction-card {
  background: linear-gradient(145deg, rgba(26, 26, 26, 0.98), rgba(18, 18, 18, 0.98)) !important;
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
  border-radius: 16px !important;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5) !important;
}

.transaction-header {
  background: rgba(0, 0, 0, 0.5);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  padding: 24px !important;
  display: flex;
  justify-content: center;
  align-items: center;
}

.header-logo {
  cursor: pointer;
}

.transaction-content {
  padding: 32px 24px !important;
  color: white;
}

/* Alert Styles */
.transaction-alert {
  background: rgba(255, 152, 0, 0.1) !important;
  border: 1px solid rgba(255, 152, 0, 0.4) !important;
  border-radius: 12px !important;
  padding: 16px !important;

  :deep(.v-alert__content) {
    color: white !important;
  }
}

.alert-title {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 18px;
  font-weight: 700;
  color: white;
  margin-bottom: 4px;
  letter-spacing: 0.5px;
}

.alert-text {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.9);
  line-height: 1.4;
}

/* Info Section */
.info-section {
  display: flex;
  align-items: flex-start;
  margin-bottom: 16px;
  padding: 12px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  border-left: 3px solid rgba(255, 255, 255, 0.3);
}

.info-text {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 15px;
  color: rgba(255, 255, 255, 0.85);
  line-height: 1.5;
  margin: 0;
  flex: 1;
}

/* Status Section */
.status-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px 16px;
  border-radius: 12px;
  margin: 16px 0;
  min-height: 160px;
}

.status-pending {
  background: rgba(255, 152, 0, 0.1);
  border: 1px solid rgba(255, 152, 0, 0.3);
}

.status-success {
  background: rgba(76, 175, 80, 0.1);
  border: 1px solid rgba(76, 175, 80, 0.3);
  animation: successPulse 0.5s ease-out;
}

@keyframes successPulse {
  0% {
    transform: scale(0.95);
    opacity: 0;
  }
  50% {
    transform: scale(1.02);
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.status-title {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 24px;
  font-weight: 700;
  color: white;
  margin-bottom: 8px;
  text-align: center;
}

.status-subtitle {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 16px;
  color: rgba(255, 255, 255, 0.7);
  text-align: center;
}

/* Transaction Hash Section */
.transaction-hash-section {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 20px;
  margin-top: 24px;
}

.hash-label {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.hash-value {
  font-family: 'Courier New', monospace;
  font-size: 13px;
  color: white;
  word-break: break-all;
  background: rgba(0, 0, 0, 0.3);
  padding: 12px;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  margin-bottom: 12px;
  line-height: 1.6;
}

.copy-btn {
  width: 100%;
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
  text-transform: none !important;
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 14px !important;
  font-weight: 600 !important;
}

.copy-btn:hover {
  background: rgba(255, 255, 255, 0.1) !important;
  border-color: rgba(255, 255, 255, 0.4) !important;
}

/* Actions */
.transaction-actions {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding: 20px 24px !important;
  background: rgba(0, 0, 0, 0.3);
}

.close-btn {
  min-width: 160px;
  height: 48px !important;
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 18px !important;
  font-weight: 700 !important;
  text-transform: none !important;
  letter-spacing: 0.5px;
  border-radius: 8px !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
  color: white !important;
  transition: all 0.3s ease;
}

.close-btn:not(:disabled):hover {
  background: rgba(255, 255, 255, 0.15) !important;
  border-color: rgba(255, 255, 255, 0.5) !important;
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
}

.close-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  border-color: rgba(255, 255, 255, 0.2) !important;
}

/* Responsive Styles */
@media (max-width: 768px) {
  .parent-nav1 {
    top: 64px;
  }

  .wallet-toggle-btn {
    width: 44px;
    min-height: 44px;
  }

  .wallet-toggle-btn.wallet-hidden {
    height: 44px;
    min-height: 44px;
  }

  .wallet-toggle-btn:not(.wallet-hidden) {
    height: auto !important;
    min-height: 44px !important;
  }

  .wallet-app-wrapper {
    width: 320px;
  }

  @keyframes slideInRight {
    from {
      opacity: 0;
      transform: translateX(100%);
      max-width: 0;
      width: 0;
    }
    to {
      opacity: 1;
      transform: translateX(0);
      max-width: 320px;
      width: 320px;
    }
  }

  @keyframes slideOutRight {
    from {
      opacity: 1;
      transform: translateX(0);
      max-width: 320px;
      width: 320px;
    }
    to {
      opacity: 0;
      transform: translateX(100%);
      max-width: 0;
      width: 0;
    }
  }

  .platform-banner {
    height: 48px;
  }

  .banner-image {
    height: 48px !important;
  }

  .banner-text {
    font-size: 18px;
  }

  .menu-item {
    min-height: 40px !important;
  }

  .menu-item-text {
    font-size: 15px !important;
  }

  .transaction-content {
    padding: 24px 16px !important;
  }

  .status-section {
    padding: 24px 12px;
    min-height: 140px;
  }

  .status-title {
    font-size: 20px;
  }

  .status-subtitle {
    font-size: 14px;
  }

  .hash-value {
    font-size: 11px;
    padding: 10px;
  }

  .close-btn {
    width: 100%;
  }
}

@media (max-width: 480px) {
  .parent-nav1 {
    left: 0;
    right: 0;
  }

  .wallet-sticky-container {
    justify-content: flex-end;
    padding-right: 12px;
  }

  .wallet-app-wrapper {
    width: calc(100vw - 72px);
    max-width: 320px;
  }

  .wallet-toggle-btn {
    width: 40px;
    min-height: 40px;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
  }

  .wallet-toggle-btn.wallet-hidden {
    height: 40px;
    min-height: 40px;
  }

  .wallet-toggle-btn:not(.wallet-hidden) {
    height: auto !important;
    min-height: 40px !important;
  }

  @keyframes slideInRight {
    from {
      opacity: 0;
      transform: translateX(100%);
      max-width: 0;
      width: 0;
    }
    to {
      opacity: 1;
      transform: translateX(0);
      max-width: calc(100vw - 72px);
      width: calc(100vw - 72px);
    }
  }

  @keyframes slideOutRight {
    from {
      opacity: 1;
      transform: translateX(0);
      max-width: calc(100vw - 72px);
      width: calc(100vw - 72px);
    }
    to {
      opacity: 0;
      transform: translateX(100%);
      max-width: 0;
      width: 0;
    }
  }

  .container-size-drawer {
    padding-right: 16px !important;
    padding-left: 16px !important;
  }

  .drawer-content {
    padding: 12px;
  }

  .drawer-header {
    padding: 12px 4px 16px 4px;
  }

  .platform-banner {
    height: 44px;
  }

  .banner-image {
    height: 44px !important;
  }

  .banner-text {
    font-size: 16px;
  }
}

/* Rest of existing styles... */
.menu-btn-icon-borderr {
  color: white!important;
  font-family: "Darker Grotesque", sans-serif!important;
  font-weight: bold!important;
  font-size: 20px!important;
  border: 1px solid black!important;
  box-shadow: none!important;
  padding-left: 8px!important;
  padding-right: 8px!important;
  transition: none !important;
  background-color: black!important;
}

.menu-btn-icon-borderr:hover {
  color: black!important;
  border: 1px solid black!important;
  background-color: white!important;
  transition: none!important;
}

.menu-btn-icon-borderr:hover .v-icon {
  color: black !important;
  transition: none!important;
}

.menu-btn-icon-borderr:before {
  display: none !important;
}

.blink {
  -webkit-animation: blink 1.5s infinite both;
  animation: blink 1.5s infinite both;
}

/* Toast Notifications Styles */
:root {
  --toastify-color-dark: #1a1a1a;
  --toastify-color-light: #ffffff;
  --toastify-color-error: #E34234;
  --toastify-color-success: #1ff050;
  --toastify-color-warning: #f0e556;
  --toastify-color-info: #007bff;
  
  --toastify-text-color-light: #ffffff;
  --toastify-text-color-dark: #ffffff;
  
  --toastify-font-family: "Darker Grotesque", sans-serif;
}

.Toastify__toast-container {
  z-index: 9999 !important;
}

.Toastify__toast {
  background: linear-gradient(145deg, rgba(26, 26, 26, 0.98), rgba(18, 18, 18, 0.98)) !important;
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
  border-radius: 12px !important;
  padding: 16px 20px !important;
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  color: white !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.5) !important;
  backdrop-filter: blur(10px) !important;
  min-height: 64px !important;
}

.Toastify__toast--default {
  background: linear-gradient(145deg, rgba(26, 26, 26, 0.98), rgba(18, 18, 18, 0.98)) !important;
  border-color: rgba(255, 255, 255, 0.3) !important;
}

.Toastify__toast--success {
  background: linear-gradient(145deg, rgba(31, 240, 80, 0.15), rgba(18, 18, 18, 0.98)) !important;
  border: 1px solid rgba(31, 240, 80, 0.5) !important;
}

.Toastify__toast--error {
  background: linear-gradient(145deg, rgba(227, 66, 52, 0.15), rgba(18, 18, 18, 0.98)) !important;
  border: 1px solid rgba(227, 66, 52, 0.5) !important;
}

.Toastify__toast--warning {
  background: linear-gradient(145deg, rgba(240, 229, 86, 0.15), rgba(18, 18, 18, 0.98)) !important;
  border: 1px solid rgba(240, 229, 86, 0.5) !important;
}

.Toastify__toast--info {
  background: linear-gradient(145deg, rgba(0, 123, 255, 0.15), rgba(18, 18, 18, 0.98)) !important;
  border: 1px solid rgba(0, 123, 255, 0.5) !important;
}

.Toastify__toast-body {
  color: white !important;
  padding: 0 !important;
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  line-height: 1.4 !important;
  letter-spacing: 0.3px !important;
}

.Toastify__toast-icon {
  width: 24px !important;
  margin-right: 12px !important;
}

.Toastify__toast-icon svg {
  fill: white !important;
}

.Toastify__toast--success .Toastify__toast-icon svg {
  fill: #1ff050 !important;
}

.Toastify__toast--error .Toastify__toast-icon svg {
  fill: #E34234 !important;
}

.Toastify__toast--warning .Toastify__toast-icon svg {
  fill: #f0e556 !important;
}

.Toastify__toast--info .Toastify__toast-icon svg {
  fill: #007bff !important;
}

.Toastify__close-button {
  color: rgba(255, 255, 255, 0.7) !important;
  opacity: 1 !important;
  transition: all 0.3s ease !important;
}

.Toastify__close-button:hover {
  color: white !important;
  opacity: 1 !important;
}

.Toastify__close-button > svg {
  height: 18px !important;
  width: 18px !important;
}

.Toastify__progress-bar {
  height: 3px !important;
  border-radius: 0 0 12px 12px !important;
}

.Toastify__progress-bar--default {
  background: linear-gradient(90deg, rgba(255, 255, 255, 0.3), rgba(255, 255, 255, 0.6)) !important;
}

.Toastify__progress-bar--success {
  background: linear-gradient(90deg, rgba(31, 240, 80, 0.5), #1ff050) !important;
}

.Toastify__progress-bar--error {
  background: linear-gradient(90deg, rgba(227, 66, 52, 0.5), #E34234) !important;
}

.Toastify__progress-bar--warning {
  background: linear-gradient(90deg, rgba(240, 229, 86, 0.5), #f0e556) !important;
}

.Toastify__progress-bar--info {
  background: linear-gradient(90deg, rgba(0, 123, 255, 0.5), #007bff) !important;
}

/* Toast Animation */
@keyframes toastSlideIn {
  from {
    transform: translate3d(110%, 0, 0);
    opacity: 0;
  }
  to {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
}

@keyframes toastSlideOut {
  from {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
  to {
    transform: translate3d(110%, 0, 0);
    opacity: 0;
  }
}

.Toastify__toast--top-right,
.Toastify__toast--bottom-right {
  animation: toastSlideIn 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.Toastify__toast--top-left,
.Toastify__toast--bottom-left {
  animation: toastSlideIn 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

/* Responsive */
@media only screen and (max-width: 480px) {
  .Toastify__toast-container {
    width: calc(100vw - 32px) !important;
    padding: 0 !important;
    left: 16px !important;
    right: 16px !important;
    margin: 0 !important;
  }

  .Toastify__toast {
    margin-bottom: 12px !important;
    border-radius: 10px !important;
    padding: 14px 16px !important;
    font-size: 15px !important;
    min-height: 56px !important;
  }

  .Toastify__toast-icon {
    width: 20px !important;
    margin-right: 10px !important;
  }

  .Toastify__close-button > svg {
    height: 16px !important;
    width: 16px !important;
  }
}

/* Bottom Center Position - dla consistency z poprzednimi toastami */
.Toastify__toast-container--bottom-center {
  bottom: 100px !important; /* Nad playerem */
}

@media only screen and (max-width: 768px) {
  .Toastify__toast-container--bottom-center {
    bottom: 110px !important;
  }
}

@media only screen and (max-width: 480px) {
  .Toastify__toast-container--bottom-center {
    bottom: 150px !important; /* Więcej miejsca dla większego playera */
  }
}

.v-navigation-drawer {
  -webkit-overflow-scrolling: touch !important;
  touch-action: pan-y !important;
}

.v-navigation-drawer__content {
  overflow-y: auto !important;
  -webkit-overflow-scrolling: touch !important;
  touch-action: pan-y !important; 
}

.overlay {
  position: relative;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  display: flex;
  justify-content: start;
  padding-left: 8px;
  align-items: center;
  opacity: 1;
  transition: opacity 0.3s ease;
  border-radius: 10px;
  border: 0px solid black;
  height: 36px;
}

.overlay-text {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 18px !important;
  font-weight: bold !important;
}

.image-container2 {
  position: relative;
  border: 0px solid black;
  border-radius: 0px;
}

.image-container2:hover .overlay {
  opacity: 0;
  cursor: pointer;
  border: 1px solid white;
}

.loading-spinner {
  position: absolute;
  top: 41%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
  background-color: transparent;
}

.loading-spinner2 {
  position: absolute;
  z-index: 2;
  background-color: transparent;
}

::-webkit-scrollbar {
  width: 4px!important;
  background: transparent!important;
  background-color: transparent!important;
  -webkit-overflow-scrolling: auto !important;
  border-radius:10px!important;
  -webkit-appearance: none !important;
}

::-webkit-scrollbar-track {
  background: transparent!important;
  background-color: transparent!important;
  border-radius: 10px!important;
  -webkit-appearance: none !important;
}

.overlay-grey {
  background-color: black !important;
  padding: 4px !important;
  margin: 3px !important;
  border: 1px solid white !important;
  border-radius: 10px !important;
  overflow-y: auto!important;
  overflow-x: hidden!important;
  flex-grow: 1;
  min-height: calc(100dvh - 80px);
  scrollbar-color: transparent transparent;
  scrollbar-width: thin !important;
  scrollbar-gutter: stable !important;
  -webkit-overflow-scrolling: touch !important;
  touch-action: pan-y !important;
  overscroll-behavior: contain !important;
  outline: none !important;
}

.overlay-grey::-webkit-scrollbar {
  width: 4px !important;
  background: transparent !important;
}

.overlay-grey::-webkit-scrollbar-track {
  background: transparent !important;
  border-radius: 10px !important;
}

.overlay-grey::-webkit-scrollbar-thumb {
  background: #2a2a2a !important;
  border-radius: 10px !important;
}

.overlay-grey::-webkit-scrollbar-thumb:hover {
  background: #404040 !important;
}

.overlay-grey-web {
  background-color: black !important;
  padding: 4px !important;
  margin: 3px !important;
  border: 0px solid transparent !important;
  border-radius: 10px !important;
  overflow-y: hidden!important;
  flex-grow: 1;
  min-height: calc(100dvh - 128px);
  scrollbar-color: transparent transparent;
  scrollbar-width: thin !important;
  scrollbar-gutter: stable !important;
}

.overlay-grey-web:hover {
  overflow-y: scroll;
  scrollbar-color: #2a2a2a transparent;
}

.errorBox {
  background-color: black !important;
  border: 1px solid #E34234 !important;
}

.okBox {
  background-color: black !important;
  border: 1px solid #1ff050 !important;
}

#bkgrdVideoFunc22 {
  background-color: transparent !important;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  max-height: 100dvh !important;
  object-fit: cover;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}

.disable-scroll {
  overflow: hidden !important;
}

#app {
  -webkit-font-smoothing: antialiased !important;
  -moz-osx-font-smoothing: grayscale !important;
  font-family: "Darker Grotesque", sans-serif !important;
}

#body {
  background-color: transparent !important;
  text-rendering: optimizeLegibility !important;
}

#parent-civ {
  position: relative !important;
  background-color: black !important;
  padding-top: 0px !important;
  padding: 0 !important;
  margin: 0 !important;
}

.email-font-overflow {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 14px;
  max-width: 80px;
  white-space: normal!important;
  text-overflow: ellipsis!important;
  color: white!important;
}

.email-font-overflow-black {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 14px;
  min-width: 140px;
  white-space: normal!important;
  text-overflow: ellipsis!important;
  color: black!important;
}

.container-size {
  padding-right: 24px;
  padding-left: 24px;

  @media (min-width: 960px) {
    max-width: 1608px;
  }
}

.container-size-top {
  padding-right: 24px;
  padding-left: 24px;
  background-color: black !important;
  width: 100vw !important;
}

.menu-btn-close {
  color: white !important;
  font-family: "Darker Grotesque", sans-serif !important;
  font-weight: bold !important;
  font-size: 18px !important;
  transition: none !important;
  margin-left: 10px !important;
  padding-left: 2px !important;
  margin-right: 10px !important;
  padding-right: 2px !important;
  background-color: transparent !important;
}

.menu-btn-close:hover {
  color: white !important;
  background-color: transparent !important;
  transition: none !important;
}

.menu-btn-close:hover .v-btn__overlay {
  background-color: transparent !important;
}

.icon-menu:hover .v-btn__overlay {
  background-color: transparent !important;
}

.menu-btn-close::before {
  content: "" !important;
  position: absolute !important;
  left: 5px !important;
  top: 34px !important;
  width: 85% !important;
  height: 1px !important;
  background-color: white !important;
  opacity: 0 !important;
}

.menu-btn-close:hover::before {
  opacity: 1 !important;
}

.title-expansion {
  background-color: black !important;
  color: white !important;
  padding: 0 !important;
  min-height: 0 !important;
}

.title-text {
  background-color: black !important;
  color: white !important;
}

.panel-expansion {
  background-color: black !important;
}

.v-expansion-panel-title__overlay {
  background-color: black !important;
}

.v-expansion-panel-title__icon {
  padding-right: 12px !important;
}

.icon-exp-sub {
  color: white !important;
  padding: 0 !important;
  margin: 0 !important;
  padding-right: 20px !important;
  padding-top: 14px !important;
  opacity: 1 !important;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s ease !important;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0 !important;
}

.text-head {
  font-size: 50px !important;
  line-height: 0.9 !important;
  font-weight: 500 !important;

  @media (min-width: 600px) {
    font-size: 64px !important;
    font-weight: 500 !important;
    line-height: 0.9 !important;
  }

  @media (min-width: 1280px) {
    font-size: 88px !important;
    font-weight: 500 !important;
    line-height: 0.9 !important;
  }
}

.fonts-head {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 40px !important;
  font-weight: 500 !important;
  color: white;
  word-spacing: normal !important;
  line-height: 1 !important;
  display: inline-block !important;
}

.fonts-desc {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 28px !important;
  font-weight: 500 !important;
  color: white;
  word-spacing: normal !important;
  line-height: 1 !important;
  display: inline-block !important;

  @media (min-width: 600px) {
    font-size: 32px !important;
  }

  @media (min-width: 1280px) {
    font-size: 36px !important;
  }
}

.fonts-desc2 {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 36px !important;
  font-weight: 500 !important;
  color: white;
  word-spacing: normal !important;
  line-height: 1 !important;
  display: inline-block !important;

  @media (min-width: 600px) {
    font-size: 38px !important;
  }

  @media (min-width: 1280px) {
    font-size: 42px !important;
  }
}

.fonts-desc3 {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 29px !important;
  font-weight: 500 !important;
  color: white;
  word-spacing: normal !important;
  line-height: 1 !important;
  display: inline-block !important;

  @media (min-width: 600px) {
    font-size: 31px !important;
  }

  @media (min-width: 1280px) {
    font-size: 35px !important;
  }
}

.fonts-desc4 {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 20px !important;
  font-weight: 500 !important;
  color: white;
  word-spacing: normal !important;
  line-height: 1 !important;
  display: inline-block !important;

  @media (min-width: 600px) {
    font-size: 26px !important;
  }

  @media (min-width: 1280px) {
    font-size: 30px !important;
  }
}

.fonts-desc5 {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 26px !important;
  font-weight: 500 !important;
  color: white;
  word-spacing: normal !important;
  line-height: 1 !important;
  display: inline-block !important;

  @media (min-width: 600px) {
    font-size: 26px !important;
  }

  @media (min-width: 1280px) {
    font-size: 30px !important;
  }
}

.fonts-nb {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 24px !important;
  font-weight: 400 !important;
  color: white;

  @media (min-width: 600px) {
    font-size: 30px !important;
  }

  @media (min-width: 1280px) {
    font-size: 34px !important;
  }
}

.fonts {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 24px !important;
  color: white;

  @media (min-width: 600px) {
    font-size: 30px !important;
  }

  @media (min-width: 1280px) {
    font-size: 34px !important;
  }
}

.fonts-white {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 20px !important;
  color: white;

  @media (min-width: 600px) {
    font-size: 22px !important;
  }

  @media (min-width: 1280px) {
    font-size: 24px !important;
  }
}

.fonts-small-black {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 16px !important;
  color: white !important;

  @media (min-width: 600px) {
    font-size: 20px !important;
  }

  @media (min-width: 1280px) {
    font-size: 22px !important;
  }
}

.fonts-desc-black {
  font-family: "Darker Grotesque", sans-serif !important;
  color: white !important;
  font-size: 14px !important;

  @media (min-width: 600px) {
    font-size: 16px !important;
  }

  @media (min-width: 1280px) {
    font-size: 18px !important;
  }
}

.fonts-small {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 16px !important;

  @media (min-width: 600px) {
    font-size: 20px !important;
  }

  @media (min-width: 1280px) {
    font-size: 22px !important;
  }
}

.font2-small {
  font-family: "Cormorant Garamond", serif !important;
  font-weight: 500 !important;
  font-size: 16px !important;

  @media (min-width: 600px) {
    font-size: 20px !important;
  }

  @media (min-width: 1280px) {
    font-size: 22px !important;
  }
}

.font2-head {
  font-family: "Cormorant Garamond", serif !important;
  font-weight: 600 !important;
  font-size: 24px !important;

  @media (min-width: 600px) {
    font-size: 28px !important;
  }

  @media (min-width: 1280px) {
    font-size: 34px !important;
  }
}

.font3-head {
  font-family: "Cormorant Garamond", serif !important;
  font-weight: 500 !important;
  font-size: 24px !important;
  font-style: italic !important;
  word-spacing: normal !important;
  line-height: 1 !important;

  @media (min-width: 600px) {
    font-size: 28px !important;
  }

  @media (min-width: 1280px) {
    font-size: 34px !important;
  }
}

.font4-head {
  font-family: "Cormorant Garamond", serif !important;
  font-weight: 500 !important;
  font-size: 24px !important;
  word-spacing: normal !important;
  line-height: 1 !important;

  @media (min-width: 600px) {
    font-size: 28px !important;
  }

  @media (min-width: 1280px) {
    font-size: 34px !important;
  }
}

.font2 {
  font-family: "Cormorant Garamond", serif !important;
  font-weight: 500 !important;
  font-size: 16px !important;

  @media (min-width: 600px) {
    font-size: 18px !important;
  }

  @media (min-width: 1280px) {
    font-size: 20px !important;
  }
}

.container {
  width: 100% !important;
  margin-right: auto;
  margin-left: auto;

  @media (min-width: 600px) {
    width: 100% !important;
  }

  @media (min-width: 1280px) {
    max-width: 1225px !important;
  }
}

.textVideo {
  position: absolute !important;
  bottom: 0 !important;
  margin-left: auto !important;
  margin-right: auto !important;
  width: 100vw !important;
}

.textPanel {
  margin-right: auto !important;
  padding-left: 320px !important;
  width: 100vw !important;
}

.textPanelFull {
    width: 100dvw !important;

}

.textPanelMobile {
  margin-right: 0px !important;
  padding-left: 110px !important;
  width: 100vw !important;
}

.textPanelMobileXs {
  margin-right: 0px !important;
  padding-left: 0px !important;
  width: 100vw !important;
}

.videoMargins {
  margin-left: 0px !important;
  margin-right: 0px !important;

  @media (min-width: 1280px) {
    margin-left: 230px !important;
    margin-right: 230px !important;
  }
}

.videoMargins2 {
  margin-left: 20px !important;
  margin-right: 20px !important;

  @media (min-width: 1280px) {
    margin-left: 20px !important;
    margin-right: 20px !important;
  }
}

.divider {
  max-height: 2px !important;
  height: 2px !important;
  color: white !important;
  opacity: 0.9 !important;
  padding-bottom: 12px !important;
}

.dividerxs {
  max-height: 2px !important;
  height: 2px !important;
  color: white !important;
  opacity: 0.9 !important;
  padding-bottom: 6px !important;
}

.btn-wrap-text {
  max-width: 100% !important;
  display: inline-block !important;
  line-height: 1.1 !important;
}

.btn-wrap-text:hover {
  text-decoration: underline !important;
  cursor: pointer !important;
  text-decoration-thickness: 1px !important;
  text-underline-offset: 3px !important;
}

.fonts-xsmall {
  font-family: "Darker Grotesque", sans-serif !important;
  font-weight: 600 !important;
  font-size: 22px !important;
  word-spacing: normal !important;

  @media (min-width: 600px) {
    font-size: 22px !important;
  }

  @media (min-width: 1280px) {
    font-size: 22px !important;
  }
}

.fonts-xsmall2 {
  font-family: "Darker Grotesque", sans-serif !important;
  font-weight: 500 !important;
  font-size: 22px !important;
  word-spacing: normal !important;
  line-height: 1 !important;

  @media (min-width: 600px) {
    font-size: 22px !important;
  }

  @media (min-width: 1280px) {
    font-size: 22px !important;
  }
}

.fonts-xsmall3 {
  font-family: "Darker Grotesque", sans-serif !important;
  font-weight: 500 !important;
  font-size: 20px !important;
  word-spacing: normal !important;
  line-height: 1 !important;

  @media (min-width: 600px) {
    font-size: 22px !important;
  }

  @media (min-width: 1280px) {
    font-size: 22px !important;
  }
}

.fonts-xsmall-date {
  font-family: "Darker Grotesque", sans-serif !important;
  font-weight: 500 !important;
  font-size: 18px !important;
  word-spacing: normal !important;
  line-height: 1.1 !important;

  @media (min-width: 600px) {
    font-size: 18px !important;
  }

  @media (min-width: 1280px) {
    font-size: 18px !important;
  }
}

.image-container:hover {
  cursor: pointer !important;
}

.image-container:hover .image-link {
  cursor: pointer !important;
}

.image-container:hover .btn-wrap-text {
  text-decoration: underline !important;
  cursor: pointer !important;
  text-decoration-thickness: 1px !important;
  text-underline-offset: 3px !important;
}

.page-top {
  margin-top: 0px !important;
  padding-top: 40px !important;
}

.page-bottom {
  padding-bottom: 30px !important;
}

.v-field--variant-filled .v-field__overlay {
  background-color: white !important;
}

.logo-modal.v-responsive__sizer {
  padding-bottom: 1px;
}

.results-font {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 18px !important;
  min-width: 100%;
  max-width: 100%;
  border-radius: 10px;
  border: 1px solid black!important;
  background-color: #121212 !important;
}

.results-font-small {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 16px !important;
  min-width: 100%;
  max-width: 100%;
  border-radius: 10px;
  border: 1px solid black!important;
  background-color: #121212 !important;
}

.results-font-ok {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 18px !important;
  min-width: 100%;
  max-width: 100%;
  border-radius: 10px;
  border: 1px solid #1ff050!important;
  background-color: #121212 !important;
}

.results-font-pending {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 18px !important;
  min-width: 100%;
  max-width: 100%;
  border-radius: 10px;
  border: 1px solid #f0e556 !important;
  background-color: #121212 !important;
}

.v-field--variant-filled .v-field__overlay {
  border-top-left-radius: 10px !important;
  border-top-right-radius: 10px !important;
}

.v-text-field .v-label {
  color: white !important;
  font-size: 16px !important;
}

.v-label {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 18px !important;
  min-width: 100%;
  max-width: 100%;
  color: black !important;
  opacity: 1 !important;

  @media (min-width: 600px) {
    font-size: 20px !important;
  }

  @media (min-width: 1280px) {
    font-size: 24px !important;
  }
}

.v-input--disabled .v-input__details {
  color: white !important;
  opacity: 1 !important;
}

.v-field--disabled {
  opacity: 1 !important;
}

.v-input--disabled .v-field--variant-filled .v-field__outline::before {
  opacity: 1 !important;
}

.v-input--error:not(.v-input--disabled) .v-input__details .v-messages {
  color: #e34234 !important;
}

.v-badge--inline .v-badge__badge {
  font-size: 18px !important;
  height: 28px !important;
}

.v-snackbar {
  z-index: 9999;
}

.v-snackbar__wrapper {
  border-radius: 0px !important;
}

.fonts-black2 {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 20px !important;
  color: white !important;
}

.v-btn {
  text-transform: none !important;
  box-shadow: none !important;
}

.v-btn:hover>.v-btn__overlay {
  --v-hover-opacity: 0;
  opacity: 0;
}

.v-btn[aria-haspopup=menu][aria-expanded=true]>.v-btn__overlay {
  --v-hover-opacity: 0;
  opacity: 0;
}

.v-btn[aria-haspopup=menu][aria-expanded=true]:hover>.v-btn__overlay {
  --v-hover-opacity: 0;
  opacity: 0;
}

.v-btn--disabled.v-btn--variant-elevated .v-btn__overlay {
  opacity: 1;
  background-color: #121212 !important;
}

input:-webkit-autofill,
input:-webkit-autofill:focus {
  transition: background-color 0s 600000s, color 0s 600000s !important;
}

.menu-btn-icon-border3.bg-primary {
  background-color: black !important;
}

.menu-btn-icon-border3 {
  color: white !important;
  font-family: "Darker Grotesque", sans-serif !important;
  font-weight: bold !important;
  font-size: 20px !important;
  border: 1px solid black !important;
  box-shadow: none !important;
  padding-left: 8px !important;
  padding-right: 8px !important;
  transition: none !important;
  background-color: black !important;
}

.menu-btn-icon-border3:hover {
  color: black !important;
  border: 1px solid black !important;
  background-color: white !important;
  transition: none !important;
}

.menu-btn-icon-border3:hover .v-icon {
  color: black !important;
  transition: none !important;
}

.menu-btn-icon-border3:before {
  display: none !important;
}

.v-selection-control__input>.v-icon {
  border: 0px solid white !important;
  color: white !important;
  opacity: 1 !important;
}

.nomenu-btn-page {
  color: white;
  font-family: "Darker Grotesque", sans-serif;
  font-weight: 500;
  font-size: 16px;
  transition: none !important;
  background-color: transparent !important;
  margin-left: 10px;
  padding-left: 2px;
  margin-right: 10px;
  padding-right: 2px;
}

.nomenu-btn-page.active,
.nomenu-btn-page:hover {
  color: white;
  background-color: transparent !important;
  transition: none;
}

.nomenu-btn-page::before {
  content: "";
  position: absolute;
  left: 0px;
  top: 27px;
  width: 100%;
  height: 1px;
  background-color: white;
  opacity: 1;
}

.nomenu-btn-page.active::before,
.nomenu-btn-page:hover::before {
  opacity: 0.3;
}

.v-input__details {
  min-height: 18px;
  padding-top: 2px;
  padding-bottom: 2px;
}

.dialog-login-signup {
  border: 2px solid black;
  border-radius: 16px;
}

.transitionblur {
  transition: 0.25s filter linear !important;
  -webkit-transition: 0.25s -webkit-filter linear!important;
  -moz-transition: 0.25s -moz-filter linear!important;
  -ms-transition: 0.25s -ms-filter linear!important;
  -o-transition: 0.25s -o-filter linear!important;
}

.glass-blur31 {
  background: black!important;
  border: 1px solid rgba(255, 255, 255, 1)!important;
}

.glass-blur31-ok {
  background: black!important;
  border: 1px solid #1ff050!important;
}

.glass-blur311 {
  background: #2a2a2a!important;
  border: 1px solid transparent!important;
}

.glass-blur311-nohover {
  background: #2a2a2a!important;
  border: 1px solid transparent!important;
}

.glass-blur311-ok:hover {
  cursor: pointer;
  background: rgba(255,255,255,0.2)!important;
  border: 1px solid #1ff050!important;
}

.glass-blur311:hover {
  cursor: pointer;
  background: rgba(255,255,255,0.2)!important;
  border: 1px solid transparent!important;
}

.glass-blur311-ok {
  background: #2a2a2a!important;
  border: 1px solid #1ff050!important;
}

</style>
